<template>
  <label :for="IdOfInput" class="upload-style">
    <i class="fa-solid fa-cloud-arrow-up"></i>
  </label>
  <input
    type="file"
    :id="IdOfInput"
    :name="nameOfInput"
    ref="uploadMain"
    hidden
    accept="application/*"
    @change="uploadSingleFile($event)"
  />
  <div class="upload-area-cv mt-2">
    <div
      class="relative-parent"
      v-for="(image, key) in aploadedFiles"
      :key="key"
    >
      <div class="abs-mark-main" @click="removefile(image, key)">
        <font-awesome-icon :icon="['fas', 'xmark']" />
      </div>
      <div class="pdf-main">
        <img class="pdf-im" :src="pdfImg" />
        {{ image.name }}
      </div>
    </div>
  </div>
  <div class="upload-area-cv mt-2" v-if="uploadedFile && showUploaded">
    <div class="relative-parent">
      <a href="uploadedFile" target="_blank" class="pdf-main d-block">
        <img class="pdf-im" :src="pdfImg" />
        {{ uploadedFile }}
      </a>
    </div>
  </div>
</template>

<script setup>
// imports
import { ref, onMounted, defineProps } from "vue";

//props
const props = defineProps(["name", "id", "uploadedFile"]);

// reactive state
const aploadedFiles = ref([]);
const nameOfInput = ref("");
const IdOfInput = ref("");
const pdfImg = ref(require("../../assets/imgs/pdf.png"));
const uploadMain = ref(null);
const showUploaded = ref(true);

// functions

function uploadSingleFile(e) {
  showUploaded.value = false
  let selectedFiles = e.target.files;
  for (let i = 0; i < selectedFiles.length; i++) {
    aploadedFiles.value = [];
    aploadedFiles.value.push(selectedFiles[i]);
  }
}

function removefile(image, index) {
  aploadedFiles.value.splice(index, 1);
  uploadMain.value.value = "";
}

// lifecycle hooks
onMounted(() => {
  nameOfInput.value = props.name;
  IdOfInput.value = props.id;
});
</script>
